import { Button } from '@crm/ui';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/app/providers';

/** Escolha do tema claro/escuro - preferencia salva no localStorage. */
export function ThemeSelector() {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button
        variant={theme === 'light' ? 'default' : 'outline'}
        onClick={() => {
          if (theme !== 'light') toggleTheme();
        }}
      >
        <Sun className="h-4 w-4" />
        Claro
      </Button>

      <Button
        variant={theme === 'dark' ? 'default' : 'outline'}
        onClick={() => {
          if (theme !== 'dark') toggleTheme();
        }}
      >
        <Moon className="h-4 w-4" />
        Escuro
      </Button>

      <span className="text-sm text-muted-foreground">
        Tema atual: {theme === 'dark' ? 'escuro' : 'claro'}
      </span>
    </div>
  );
}
